import type { Hex } from 'viem';
import Modal from '@/shared/ui/Modal';
import SwapForm from '@/shared/ui/SwapForm';
import { showNotification } from '@/modules/show-notification';
import { useSanBalance } from '@/modules/use-san-balance';
import { fmt } from '@/modules/swap';

export default function SwapModal({
  address,
  onClose,
}: {
  address: Hex;
  onClose: () => void;
}) {
  // Same wagmi cache entry the header "Available SAN" pill reads — the swap
  // executes via LiFi, outside SendTransactionProvider, so nothing else
  // refreshes the balance and the pill kept the pre-swap number.
  const { refetch: refetchSanBalance } = useSanBalance(address);
  return (
    <Modal closeModal={onClose}>
      <div className="w-125 max-w-full rounded-md bg-background-secondary p-l max-md:w-full max-md:p-m">
        <h2 className="mb-l text-h2 font-bold text-gray-text">Swap</h2>
        <SwapForm
          address={address}
          context="header"
          onSuccess={(received, toToken) => {
            refetchSanBalance();
            showNotification(
              'info',
              `Swap successful · ${fmt(received)} ${toToken.symbol} received`,
            );
            onClose();
          }}
        />
      </div>
    </Modal>
  );
}
